module.exports = __webpack_public_path__ + "graphics/player-pause.ckh.15565774d1a2c65473a26c65b7835136.svg";